module.exports = __webpack_public_path__ + "assets/bc0ea2a2bf5e5c22564b584a65d46038.png";